import { useRouter } from 'next/router';

import { links } from '../../helper/constants';
import { generateQueryParams } from '../../helper/functions';

import iFilters from '../../interfaces/iFilters';

import { event } from '../../lib/gtag';

export default function SweepSearch(filters: iFilters, homePage?: boolean) {
  const router = useRouter();

  const vehicleSearch = () => {
    let url = links.used
    url += generateQueryParams(filters);
    
    event("vehicleSearch")

    // removing cached vehicles to prevent page crash
    if (homePage) {
      sessionStorage.removeItem("vehiclesResults")
    }
    
    sessionStorage.setItem("filtersURL", url)
    router.replace(url, undefined, { shallow: true }); 
  }

  return vehicleSearch
};
